import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import unique from '../../helper/unique'
import Message from './Message'
import { StyledRadio } from './Radio'
import { mobile } from '../../styles/media'

const RadioContainer = ({ border, children, clearable, disabled, errors, fitContent, iconGrid, multiple, grid, onChange, orientation, transparent, value }) => {
	const radioId = unique('radio')

	const message = errors.reduce((accumulator, error) => `${accumulator}${error} `, '')

	return (
		<>
			<StyledRadioContainer
				orientation={orientation}
				multiple={multiple}
				fitContent={fitContent}
				disabled={disabled}
				grid={grid}
				iconGrid={iconGrid}
				border={border}
				transparent={transparent}
			>
				{React.Children.map(children, (child) => {
					if (child) {
						return React.cloneElement(child, {
							radioId,
							clearable,
							multiple,
							onChange,
							orientation,
							transparent,
							value
						})
					}

					return null
				})}
			</StyledRadioContainer>
			{message !== '' && <Message small>{message}</Message>}
		</>
	)
}

RadioContainer.propTypes = {
	border: PropTypes.bool,
	children: PropTypes.any.isRequired,
	clearable: PropTypes.bool,
	disabled: PropTypes.bool,
	errors: PropTypes.array,
	fitContent: PropTypes.bool,
	grid: PropTypes.bool,
	iconGrid: PropTypes.bool,
	multiple: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	orientation: PropTypes.string,
	transparent: PropTypes.bool,
	value: PropTypes.any
}

RadioContainer.defaultProps = {
	border: false,
	clearable: false,
	disabled: false,
	errors: [],
	fitContent: false,
	grid: false,
	iconGrid: false,
	multiple: false,
	orientation: 'column',
	value: ''
}

export const StyledRadioContainer = styled.div`
	display: flex;
	flex-direction: ${props => props.orientation};

	> ${StyledRadio} + ${StyledRadio} {
		${props => props.orientation === 'row' ? 'margin-left: 1rem;' : 'margin-top: 1rem;'}
	}

	${props => props.grid && `
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
		grid-gap: 0.75rem;

		> * {
			margin: 0 !important;
		}
	`}

	${props => props.iconGrid && `
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));
		gap: 1rem;

		> * {
			margin: 0 !important;
		}
	`}

	${props => props.disabled && `
		opacity: 0.5;
		pointer-events: none;
	`}

	${props => props.fitContent && `
		width: fit-content;
	`}

	${props => props.border && `
		border: 1px solid ${props.transparent ? 'rgba(255, 255, 255, 0.1)' : props.theme.backgroundLight};
		border-radius: 3px;
	`}

	${mobile`
		flex-wrap: wrap;
	`}
`

export default RadioContainer
